export default "__VITE_ASSET__BNkpLbaT__"